import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-561b4aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Contact Us", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Learn more about Derivitec.", -1))
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
  /*#__PURE__*/_createElementVNode("p", null, "To speak with our team about Derivitec products and services, simply provide us with your contact information and we will respond promptly."),
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("figcaption", null, "Phone"),
    /*#__PURE__*/_createElementVNode("a", { href: "tel:+442036683682" }, "+44 (203) 668 3682")
  ]),
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("figcaption", null, "Email"),
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@derivitec.com" }, "info@derivitec.com")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Thank you for your interest in Derivitec. We look forward to connecting with you.")
], -1))
const _hoisted_5 = { class: "half" }
const _hoisted_6 = {
  key: 0,
  class: "success"
}
const _hoisted_7 = {
  key: 1,
  class: "error"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@derivitec.com" }, "email", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:+442036683682" }, "phone", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "button" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns office" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Head Office"),
    /*#__PURE__*/_createElementVNode("address", {
      itemprop: "address",
      itemscope: "",
      itemtype: "http://schema.org/PostalAddress"
    }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("span", { itemprop: "streetAddress" }, "Level 39, 1 Canada Square"),
        /*#__PURE__*/_createTextVNode(", "),
        /*#__PURE__*/_createElementVNode("span", { itemprop: "addressLocality" }, "London"),
        /*#__PURE__*/_createTextVNode("  "),
        /*#__PURE__*/_createElementVNode("span", { itemprop: "postalCode" }, "E14 5AB"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Tel: "),
        /*#__PURE__*/_createElementVNode("a", {
          href: "tel:+442036683682",
          itemprop: "telephone"
        }, "+44 (0)203 668 3682")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      width: "100%",
      height: "450",
      frameborder: "0",
      style: {"border":"0"},
      src: "https://www.google.com/maps/embed/v1/place?q=Level%2039%2C%201%20Canada%20Square%2C%20London%20%20E14%205AB&key=AIzaSyBOJ6zZLLCeUx8p94gzK6_pnCMGpPFAzro",
      allowfullscreen: ""
    })
  ])
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns office" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "US Office"),
    /*#__PURE__*/_createElementVNode("address", {
      itemprop: "address",
      itemscope: "",
      itemtype: "http://schema.org/PostalAddress"
    }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("span", { itemprop: "streetAddress" }, "450 Lexington Ave New York"),
        /*#__PURE__*/_createTextVNode(", "),
        /*#__PURE__*/_createElementVNode("span", { itemprop: "postalCode" }, "NY 10017")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      width: "100%",
      height: "450",
      frameborder: "0",
      style: {"border":"0"},
      src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.3971657995457!2d-73.97800202397225!3d40.753288571387415!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259026dac3895%3A0x2e2ca693614b3144!2s450%20Lexington%20Ave%2C%20New%20York%2C%20NY%2010017%2C%20USA!5e0!3m2!1sen!2suk!4v1710238921022!5m2!1sen!2suk",
      allowfullscreen: ""
    })
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns office" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "APAC Office"),
    /*#__PURE__*/_createElementVNode("address", {
      itemprop: "address",
      itemscope: "",
      itemtype: "http://schema.org/PostalAddress"
    }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("span", { itemprop: "streetAddress" }, "12/F Mass Mutual Tower, 33 Lockhart Road"),
        /*#__PURE__*/_createTextVNode(", "),
        /*#__PURE__*/_createElementVNode("span", { itemprop: "addressLocality" }, "Hong Kong"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" Tel: "),
        /*#__PURE__*/_createElementVNode("a", {
          href: "tel:+85231523223",
          itemprop: "telephone"
        }, "+852 3152 3223")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("iframe", {
      width: "100%",
      height: "450",
      frameborder: "0",
      style: {"border":"0"},
      src: "https://www.google.com/maps/embed/v1/place?q=10F%2C%20China%20Evergrande%20Centre%2C%2033%20Lockhart%20Rd%2C%20Wan%20Chai%2C%20Hong%20Kong&key=AIzaSyBOJ6zZLLCeUx8p94gzK6_pnCMGpPFAzro",
      allowfullscreen: ""
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_text_field = _resolveComponent("text-field")!
  const _component_dropdown = _resolveComponent("dropdown")!
  const _component_text_area_field = _resolveComponent("text-area-field")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (_ctx.success === true)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Thank you for your enquiry, we will respond in due course."))
              : _createCommentVNode("", true),
            (_ctx.success === false)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                  _createTextVNode("An error occurred sending your enquiry, please "),
                  _hoisted_8,
                  _createTextVNode(" or "),
                  _hoisted_9,
                  _createTextVNode(" to make an enquiry.")
                ]))
              : _createCommentVNode("", true),
            (_ctx.success !== true)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 2,
                  onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
                }, [
                  _createElementVNode("fieldset", {
                    disabled: _ctx.isSending || _ctx.success === false
                  }, [
                    _createVNode(_component_text_field, {
                      placeholder: "First Name",
                      modelValue: _ctx.first,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.first) = $event)),
                      class: "half"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_text_field, {
                      placeholder: "Last Name",
                      modelValue: _ctx.last,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.last) = $event)),
                      class: "half"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_text_field, {
                      placeholder: "Company Name",
                      modelValue: _ctx.company,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_text_field, {
                      placeholder: "Email",
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_text_field, {
                      placeholder: "Phone",
                      modelValue: _ctx.phone,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phone) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_dropdown, {
                      title: "Type of Firm",
                      placeholder: "Select firm type",
                      modelValue: _ctx.firm,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.firm) = $event)),
                      options: _ctx.firms
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_component_dropdown, {
                      title: "Country",
                      placeholder: "Select Country",
                      modelValue: _ctx.country,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.country) = $event)),
                      options: _ctx.countries
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_component_text_area_field, {
                      placeholder: "Enquiry",
                      modelValue: _ctx.enquiry,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.enquiry) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("button", _hoisted_11, _toDisplayString(_ctx.buttonText), 1)
                  ], 8, _hoisted_10)
                ], 32))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_12,
        _hoisted_13,
        _hoisted_14
      ]),
      _: 1
    })
  ]))
}